module.exports = __webpack_public_path__ + "static/img/qq.28d105e3.svg";